import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';
import { ToggleContainer, Section, Form } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../context/useAppContext';
import { Link } from 'react-router-dom';

export default function RateLinker({ rateTemplate = null, onChange = () => {}, rateTemplates = null }) {
    const [checked, setChecked] = React.useState(Boolean(rateTemplate));
    const { t } = useTranslation();
    const [{ organization }] = useAppContext();

    const dropdownOptions = React.useMemo(() => {
        if (!rateTemplates) {
            return [];
        }
        return rateTemplates.map(rate => ({
            text: rate.name,
            value: rate.pk,
            key: rate.pk
        }));
    }, [rateTemplates]);

    const handleClickToggle = React.useCallback(
        checked => {
            if (checked === false) {
                onChange(null);
            }
            return setChecked(checked);
        },
        [onChange]
    );

    return (
        <ToggleContainer toggle={checked} onToggle={handleClickToggle} title={t(`ticket.rates.settingsLinkTemplateToggle`)}>
            <Section>
                <Form.Field>
                    <Form.Label label={t(`ticket.rates.settingsLinkTemplateLabel`)} />
                    <Dropdown
                        clearable
                        fluid
                        search
                        selection
                        className="link-rate-dropdown"
                        options={dropdownOptions}
                        onChange={(synth, { value }) => onChange(value)}
                        value={rateTemplate}
                    />
                </Form.Field>

                {rateTemplate && (
                    <Link className="link-rate-link" target="_blank" to={`/ticket/O${organization.id}/rates/${rateTemplate}`}>
                        <span>{t('ticket.rates.editTemplateLink')}</span>
                    </Link>
                )}
            </Section>
        </ToggleContainer>
    );
}

RateLinker.propTypes = {
    rateTemplate: PropTypes.string,
    onChange: PropTypes.func,
    rateTemplates: PropTypes.array
};
